import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client'
import previouslyPurchasedQuery from './query'
import {
  IPreviouslyPurchasedVariables,
  IPreviouslyPurchasedResponse,
} from './types'

/**
 * Hook declaration to obtain a lazy query of previously purchased products.
 * @param options: LazyQueryHookOptions without the fetch-policy keys
 * @internal
 */
const useLazyPreviouslyPurchased = (
  options?: Omit<
    LazyQueryHookOptions<
      IPreviouslyPurchasedResponse,
      IPreviouslyPurchasedVariables
    >,
    'fetchPolicy' | 'nextFetchPolicy' | 'initialFetchPolicy'
  >,
) => {
  return useLazyQuery<
    IPreviouslyPurchasedResponse,
    IPreviouslyPurchasedVariables
  >(previouslyPurchasedQuery, {
    ...options,
    fetchPolicy: 'no-cache',
    // Neutralised beside the pin, not merely omitted from the type: both
    // survive the spread otherwise, and `nextFetchPolicy` would take over
    // from the second fetch onward.
    nextFetchPolicy: undefined,
    initialFetchPolicy: undefined,
  })
}

export { useLazyPreviouslyPurchased }
